import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/apiClient";
import { queryClient } from "../lib/queryClient";
import { User } from "../stores/authStore";

interface LoginRequest {
  email: string;
  password: string;
}

interface RegisterRequest {
  email: string;
  password: string;
  name: string;
  phone?: string;
}

interface AuthResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export function useLogin() {
  return useMutation({
    mutationFn: (credentials: LoginRequest) =>
      apiClient<AuthResponse>("/auth/login", {
        method: "POST",
        body: JSON.stringify(credentials),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });
    },
  });
}

export function useRegister() {
  return useMutation({
    mutationFn: (userData: RegisterRequest) =>
      apiClient<AuthResponse>("/auth/register", {
        method: "POST",
        body: JSON.stringify(userData),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });
    },
  });
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ["currentUser"],
    queryFn: () => apiClient<User>("/auth/me"),
    enabled: false, // Only fetch when explicitly called
  });
}
